import { render, staticRenderFns } from "./TitleTag.vue?vue&type=template&id=c7c4f3f2"
import script from "./TitleTag.vue?vue&type=script&lang=js"
export * from "./TitleTag.vue?vue&type=script&lang=js"
import style0 from "./TitleTag.vue?vue&type=style&index=0&id=c7c4f3f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports